<template>
	<div class="course">
		<div class="inner">
			<div class="title-box">
				<h2>企微配置教程</h2>
			</div>

			<div class="title-list">
				<h4>配置分为一下步骤：</h4>
				<span @click="jump(0)">一、企业信息设置</span> ->
				<span @click="jump(1)">二、创建快叮获客通自建应用</span> ->
				<span @click="jump(2)">三、提交信息</span> ->
				<span @click="jump(3)">四、配置应用属性</span> ->
				<span @click="jump(4)">五、配置聊天侧边栏</span> ->
				<span @click="jump(5)">六、添加员工到客户联系</span> ->
				<span @click="jump(6)">七、修改应用权限</span> ->
				<span @click="jump(7)">八、填写接收事件服务器配置</span> ->
				<span @click="jump(8)">九、通讯录设置</span>
			</div>
			<div class="step info">
				<h3 class="sub-title d_jump">一、企业信息设置</h3>
				<ul class="docs">
					<li>
						（1）打开
						<strong class="bold">【我的企业】</strong>
						，复制最下面的
						<strong class="bold">【企业ID】</strong>,填写到下方，并填写企业名称
					</li>
				</ul>
				<div class="box">
					<div class="item">
						<span class="title">企业名称:</span>
						<el-input v-model="config.company_name" placeholder="请输入企业名称" style="width: 435px;"></el-input>
					</div>
					<div class="item">
						<span class="title">企业ID:</span>
						<el-input :disabled="isEdit" v-model="config.corpid" @blur="getCallbackConfig(config.corpid)"
							placeholder="请输入企业ID" style="width: 435px;"></el-input>
					</div>
				</div>
				<img src="~assets/img/course/img1.png" alt="">
			</div>
			<div class="step">
				<h3 class="sub-title d_jump">二、创建快叮获客通自建应用</h3>
				<ul class="docs">
					<li>
						（1）打开
						<strong class="bold">【应用管理】</strong>
						，在
						<strong class="bold">【自建】</strong>
						下选择
						<strong class="bold">【创建应用】</strong>
					</li>
				</ul>
				<img src="https://assets.weibanzhushou.com/web/we-work-webapp/initial-configuration_img3.4ce24f759ccc.jpg"
					alt="">
				<ul class="docs">
					<li>
						（2）创建自建应用名称建议填写「
						<strong class="bold">【快叮获客通】</strong>
						」
						<el-button class="button copy_name" data-clipboard-text="快叮获客通" @click="copyName">复制</el-button>
						，
						<img src="~assets/img/course/logo.png" alt="" id="hideImg">
						<span @click="downloadLogo" class="downloadLogo">点击这里</span>下载应用logo进行上传，不用填写应用介绍。
					</li>
					<li>
						（3）在
						<strong class="bold">【可见范围】</strong>内
						<strong class="bold">【选择部门/成员】</strong>
						，可先选择授权给本人，之后若需要添加使用人员时可再次添加
					</li>
				</ul>
				<img src="~assets/img/course/img3.png" alt="">
			</div>
			<div class="step info">
				<h3 class="sub-title d_jump">三、提交信息</h3>
				<ul class="docs">
					<li>
						创建成功后，在创建的
						<strong class="bold">【快叮获客通】</strong>内找到
						<strong class="bold">Secret</strong>和
						<strong class="bold">Agentld</strong>,复制并填写到下方
					</li>
				</ul>
				<div class="box">
					<div class="item">
						<span class="title">AgentId:</span>
						<el-input v-model="config.agentid" placeholder="请输入AgentId" style="width: 435px;"></el-input>
					</div>
					<div class="item">
						<span class="title">Secret:</span>
						<el-input v-model="config.agent_secret" placeholder="请输入Secret" style="width: 435px;">
						</el-input>
					</div>
					<img src="~assets/img/course/img4.png" alt="">
					<img src="~assets/img/course/img5.png" alt="">
					<img src="~assets/img/course/img6.png" alt="">
				</div>
			</div>

			<div class="step">
				<h3 class="sub-title d_jump">四、配置应用属性</h3>
				<ul class="docs">
					<li>
						在创建应用成功后，进入
						<strong class="bold">【快叮获客通详情页】</strong>找到
						<strong class="bold">【开发者接口】</strong>中的
						<strong class="bold">【网页授权及JS-SDK】</strong>页面，点击
						<strong class="bold">【设置可信域名】</strong>，进行设置
					</li>
				</ul>
				<img src="~assets/img/course/img16.png" alt="">
				<div class="sub-step">
					<p>
						<span class="bold-bold"></span>复制链接填写到输入框
					</p>
					<div class="copy-box">
						<div class="textarea" data-clipboard-text="scrm.51kuaiding.com">scrm.51kuaiding.com</div>
						<div class="flex-row align-center">
							<el-button class="button copy_url1" data-clipboard-text="scrm.51kuaiding.com"
								@click="copyUrl1">复制</el-button>
						</div>
					</div>
					<div class="sub-step">
						<p>
							<span class="bold-bold">第二步：</span>填写完成后点击
							<span class="bold">【申请校验域名】</span>
						</p>
						<img src="~assets/img/course/img17.png" alt="">
					</div>
					<div class="sub-step">
						<p>
							<span class="bold-bold">第三步：</span>直接勾选
							<span class="bold">【用于OAuth2.0回调的可信域名是否校验】</span>即可
						</p>
						<img src="~assets/img/course/img18.png" alt="">
					</div>

				</div>
			</div>

			<div class="step sidebar">
				<h3 class="sub-title d_jump">五、配置聊天侧边栏</h3>
				<p>
					按照下图依次配置「
					<strong class="bold">快捷回复</strong>」、「
					<strong class="bold">客户画像</strong>」，配置成功后员工即可在侧边栏使用。
				</p>
				<!--        <div class="warning">-->
				<!--          <p class="desc">进行配置时在【客户联系】范围内的员工将会收到多条推送消息</p>-->
				<!--        </div>-->
				<ul class="docs">
					<li>
						在<strong class="bold">【快叮获客通】</strong>找到
						<strong class="bold">【配置到聊天工具栏】</strong>，点击
						<strong class="bold">【配置】</strong>，进行设置
					</li>
				</ul>
				<img src="~assets/img/course/img19.png" alt="">
				<div class="step-container">
					<div class="container">
						<ul class="docs">
							<li>
								(1) 进入<strong class="bold">【配置到聊天工具栏】</strong>，进行设置。点击
								<strong class="bold">【配置页面】</strong>进行配置
							</li>
						</ul>
						<img src="~assets/img/course/img20.png" alt="">
						<ul class="docs">
							<li>
								(2) 创建快捷回复侧边栏，请按照以下内容填写
							</li>
						</ul>
						<p class="desc">
							1、填写页面名称：快捷回复
							<el-button class="button copy_name1" data-clipboard-text="快捷回复" @click="copyName1">复制名称
							</el-button>
						</p>
						<p class="desc"> 2、填写页面内容，选择自定义，链接为： </p>
						<p class="desc" style="margin-left:21px;"></p>
						<el-button class="button copy_kjhh"
							:data-clipboard-text="'https://scrm.51kuaiding.com/scrm/sidebar/quick_reply?corpid=' + config.corpid"
							@click="copyKjhh">复制链接</el-button>
						<img src="~assets/img/course/img21.png" alt="">
						<ul class="docs">
							<li>
								(3) 创建客户画像侧边栏，请按照以下内容填写
							</li>
						</ul>
						<p class="desc">
							1、填写页面名称：客户画像
							<el-button class="button copy_name2" data-clipboard-text="客户画像" @click="copyName2">复制名称
							</el-button>
						</p>
						<p class="desc"> 2、填写页面内容，选择自定义，链接为： </p>
						<p class="desc" style="margin-left:21px;"></p>
						<el-button class="button copy_khhx"
							:data-clipboard-text="'https://scrm.51kuaiding.com/scrm/sidebar/customer_info?corpid=' + config.corpid"
							@click="copyKhhx">复制链接</el-button>
						<img src="~assets/img/course/img22.png" alt="">
					</div>

				</div>
			</div>

			<div class="step">
				<h3 class="sub-title d_jump">六、添加员工到客户联系</h3>
				<ul class="docs">
					<li>
						选择
						<strong class="bold">【客户联系】</strong>-
						<strong class="bold">【权限配置】</strong>，点击
						<strong class="bold">【添加/修改】</strong>将成员添加到使用范围，建议选择全部成员
					</li>
				</ul>
				<div class="warning">
					<p class="desc">员工只有配置了【使用范围和管理规则】才可以使用客户联系，添加外部联系人等权限，请确保客服等人员被添加客户联系权限，否则可能会导致获客通部分功能无法使用</p>
				</div>
				<img src="~assets/img/course/img23.png" alt="">
			</div>
			<div class="step change-right">
				<h3 class="sub-title d_jump">七、修改应用权限</h3>
				<ul class="docs">
					<li>
						(1) 切换到
						<strong class="bold">【客户联系】</strong>-
						<strong class="bold">【客户】</strong>，点击
						<strong class="bold">【API】</strong>展开，复制
						<strong class="bold">Secret</strong>后，填写到下方
					</li>
				</ul>
				<div class="box">
					<div class="item">
						<span class="title">Secret:</span>
						<el-input v-model="config.customer_secret" placeholder="请输入Secret" style="width: 435px;">
						</el-input>
					</div>
				</div>
				<img src="~assets/img/course/img8.png" alt="">
				<img src="~assets/img/course/img9.png" alt="">
				<img src="~assets/img/course/img6.png" alt="">
				<ul class="docs">
					<li>
						(2) 填写Secret后，选择
						<strong class="bold">【可调用应用】</strong>，点击
						<strong class="bold">【设置】</strong>，如果在此之前已经进行过应用配置，点击
						<strong class="bold">【修改】</strong>
					</li>
				</ul>
				<img src="~assets/img/course/img10.png" alt="">
				<ul class="docs">
					<li>
						(3) 勾选之前创建的
						<strong class="bold">【快叮获客通】</strong>
					</li>
				</ul>
				<img src="~assets/img/course/img24.png" alt="">
			</div>
			<div class="step callback">
				<h3 class="sub-title d_jump">八、填写接收事件服务器配置</h3>
				<ul class="docs">
					<li>

						(1) 点击
						<strong class="bold">【客户联系】</strong>-
						找到<strong class="bold">【接收事件服务器】</strong>
					</li>
				</ul>
				<img src="~assets/img/course/img25.png" alt="">
				<ul class="docs">
					<li>
						(2) 将以下内容依次填写到页面
						<strong class="bold">【接收消息服务器】</strong>下对应的输入框中
					</li>
				</ul>
				<div class="box">
					<div class="item">
						<p class="title">URL:</p>
						<p class="title" style="font-size: 14px; margin-top: 15px;">{{info.url}}{{corpkey}}</p>
					</div>
					<el-button class="button copy_url" :data-clipboard-text="info.url+corpkey" @click="copyUrl">复制
					</el-button>
				</div>
				<div class="box">
					<div class="item">
						<p class="title">Token:</p>
						<p class="title" style="font-size: 14px; margin-top: 15px;">{{config.token}}</p>
					</div>
					<el-button class="button copy_token" :data-clipboard-text="config.token" @click="copyToken">复制
					</el-button>
				</div>
				<div class="box">
					<div class="item">
						<p class="title">EncodingAESKey:</p>
						<p class="title" style="font-size: 14px; margin-top: 15px;">{{config.encodingaeskey}}</p>
					</div>
					<el-button class="button copy_aeskey" :data-clipboard-text="config.encodingaeskey"
						@click="copyAESKey">复制</el-button>
				</div>

				<div class="warning">
					<!--          <p class="desc">在【选择需要接受的事件类型】中，一定要勾选【用户发送的普通消息】和【外部联系人变更回调】，否则会导致部分功能无法使用</p>-->
					<img src="~assets/img/course/img26.png" alt="">
				</div>
			</div>
			<div class="step info">
				<h3 class="sub-title d_jump">九、通讯录设置</h3>
				<ul class="docs">
					<li>
						打开
						<strong class="bold">【管理工具】</strong>找到
						<strong class="bold">【通讯录同步】</strong>，点击
						<strong class="bold">【开启API接口同步】</strong>，然后复制
						<strong class="bold">【Secret】</strong>填在下方
					</li>
				</ul>
				<img src="~assets/img/course/img13.png" alt="">
				<img src="~assets/img/course/img14.png" alt="">
				<img src="~assets/img/course/img15.png" alt="">


				<div class="box">
					<div class="item">
						<span class="title">Secret:</span>
						<el-input v-model="config.address_secret" placeholder="请输入通讯录Secret" style="width: 435px;">
						</el-input>
					</div>

					<ul class="docs">
						<li>
							(1) 点击
							<strong class="bold">【接收事件服务器】</strong>
						</li>
					</ul>
					<img src="~assets/img/course/img27.png" alt="">
					<ul class="docs">
						<li>
							(2) 将以下内容依次填写到页面
							<strong class="bold">【接收消息服务器】</strong>下对应的输入框中
						</li>
					</ul>
					<div class="box" style="display: flex;align-items: center">
						<div class="item1">
							<p class="title">URL:</p>
							<p class="title" style="font-size: 14px;margin-top: 15px;">{{info.url}}{{corpkey}}</p>
						</div>
						<el-button class="button copy_url" style="margin-left: 10px;"
							:data-clipboard-text="info.url+corpkey" @click="copyUrl">复制</el-button>
					</div>
					<div class="box" style="display: flex;align-items: center">
						<div class="item1">
							<p class="title">Token:</p>
							<p class="title" style="font-size: 14px;margin-top: 15px;">{{config.token}}</p>
						</div>
						<el-button class="button copy_token" style="margin-left: 10px;" :data-clipboard-text="config.token"
							@click="copyToken">复制</el-button>
					</div>
					<div class="box" style="display: flex;align-items: center">
						<div class="item1">
							<p class="title">EncodingAESKey:</p>
							<p class="title" style="font-size: 14px;margin-top: 15px;">{{config.encodingaeskey}}</p>
						</div>
						<el-button class="button copy_aeskey" style="margin-left: 10px;"
							:data-clipboard-text="config.encodingaeskey" @click="copyAESKey">复制</el-button>
					</div>

					<div class="warning">
						<!--          <p class="desc">在【选择需要接受的事件类型】中，一定要勾选【用户发送的普通消息】和【外部联系人变更回调】，否则会导致部分功能无法使用</p>-->
						<img src="~assets/img/course/img26.png" alt="">
					</div>

					<!-- <ul class="docs" v-if="!isEdit">
				<li>
				  (3) 选择获客通成员
				</li>
			</ul> -->
					<!-- <div class="item" v-if="!isEdit">
				<span class="title">获客通成员:</span>
				<el-select
					@click.native="getUser"
					v-model="user_info"
					multiple
					filterable
					allow-create
					default-first-option
					style="margin-top: 10px;"
					placeholder="请选择成员">
					<el-option
						  v-for="item in user_list"
						  :key="item.userid"
						  :label="item.name"
						  :value="item.userid">
					</el-option>
				</el-select>
			</div> -->

				</div>

				<el-button @click="save">保存</el-button>
			</div>


		</div>

		<div v-if="btnFlag" class="to-up" @click="backTop">
			<span>
				<svg t="1622446462467" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
					p-id="3109" width="48" height="48">
					<path
						d="M511.99872 0C229.23008 0 0 229.23136 0 512c0 282.76992 229.23008 512 512 512 282.7712 0 512-229.23008 512-512C1024 229.23136 794.76992 0 511.99872 0zM743.37024 604.99968c-8.61696 0-16.47744-3.49312-22.1376-9.13792L542.752 417.46176l0 414.38592c0 17.24544-13.98528 31.2448-31.24608 31.2448-17.27744 0-31.27552-14.00064-31.27552-31.2448l0-0.02944L480.2304 418.432 303.33952 595.3408c-5.7088 5.96736-13.7536 9.67552-22.67904 9.67552-17.35168 0-31.41376-14.06208-31.41376-31.4304 0-8.6144 3.49184-16.43008 9.09312-22.0928l230.90816-230.9376c5.72288-6.03136 13.76768-9.81504 22.74048-9.81504 8.8128 0 16.79872 3.67744 22.47552 9.53856L765.61408 551.4624l0 0.02944c5.64736 5.6448 9.13792 13.47712 9.13792 22.12224C774.752 590.95296 760.70656 604.99968 743.37024 604.99968zM772.9216 281.8624 251.07712 281.8624c-17.2608 0-31.27552-14.03008-31.27552-31.2768 0-17.2928 14.01472-31.27808 31.27552-31.27808l521.84576 0c17.25952 0 31.27808 13.98528 31.27808 31.27808C804.19968 267.83104 790.1824 281.8624 772.9216 281.8624z"
						p-id="3110" fill="#2a75ea"></path>
				</svg>
			</span>
		</div>

		<Dialog :show.sync="synch_show" :name_width="synch_dialog" class="dialog">
			<span slot="body">
				<!--        同步资料选择  1-->
				<div class="synch_select" v-if="dialog_type === 1">
					<span>
						<svg t="1624935075201" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2431" width="80" height="80">
							<path
								d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z"
								fill="#52C41A" p-id="2432"></path>
						</svg>
					</span>
					<div class="title-box">
						<p class="title">企业微信接入成功</p>
						<p class="small-title">接下来我们需要同步组织架构、标签信息、客户信息、群信息</p>
					</div>
				</div>
				<!--        同步资料进度  2-->
				<div class="synch_speed" v-else-if="dialog_type === 2">
					<el-progress :percentage="progress_bar | round" style="height: 10px;"></el-progress>
					<div class="return_info">
						<p v-if="synch_select_info.class_info">
							组织架构信息&nbsp;
							<span class="wait" v-if="class_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="class_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="class_state === 2">同步成功</span>&nbsp;
							<span class="data-text" v-if="class_state === 2">{{class_msg}}条数据</span>
						</p>
						<p v-if="synch_select_info.label_info">
							标签信息&nbsp;
							<span class="wait" v-if="label_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="label_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="label_state === 2">同步成功</span>&nbsp;
							<span class="data-text" v-if="label_state === 2">{{label_msg}}条数据</span>
						</p>
						<p v-if="synch_select_info.member_info">
							客户信息&nbsp;
							<span class="wait" v-if="member_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="member_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="member_state === 2">同步成功</span>&nbsp;
							<span class="data-text" v-if="member_state === 1 || member_state === 2">{{member_msg}}条数据</span>
						</p>
						<p v-if="synch_select_info.group_info">
							群信息&nbsp;
							<span class="wait" v-if="group_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="group_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="group_state === 2">同步成功</span>&nbsp;
							<span class="data-text" v-if="group_state === 1 || group_state === 2">{{group_msg}}条数据</span>
						</p>
					</div>
				</div>
				<!--        同步成功-->
				<div class="synch_success" v-else-if="dialog_type === 3">
					<span>
						<svg t="1624935075201" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2431" width="80" height="80">
							<path
								d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z"
								fill="#52C41A" p-id="2432"></path>
						</svg>
					</span>
					<div class="title-box">
						<p class="title">数据同步成功</p>
						<p class="small-title">您可以开始使用系统啦</p>
					</div>
				</div>
			</span>
			<div slot="footer">
				<el-button v-if="dialog_type === 1" type="primary" @click="start_synch_dialog" class="blueBtn">开始同步
				</el-button>
				<el-button v-else-if="dialog_type === 2" type="primary" @click="suspend_synch_dialog" class="suspend">暂停
				</el-button>
				<el-button v-else-if="dialog_type === 3" type="primary" @click="return_synch_dialog" class="blueBtn">返回
				</el-button>
				<el-button @click="close_synch_dialog">取 消</el-button>
			</div>
		</Dialog>

	</div>
</template>

<script>
	import {
		setQwConfig,
		getQwUser,
		getQwConfig,
		editQwConfig,
		synchroQwDepartment,
		synchroQwTag,
		synchroQwCustomer,
		getQwMember,
		synchroQwCustomerBase,
		getCallbackConfig
	} from 'network/hk_wechat'
	import Clipboard from 'clipboard'
	import Dialog from "components/content/dialog/Dialog";

	export default {
		name: "Course", 
		components: {
			Dialog
		},
		data() {
			return {
				config: {
					id: null,
					company_name: '',
					corpid: '',
					agentid: '',
					agent_secret: '',
					customer_secret: '',
					address_secret: '',
					user_info: [],
					userid: [],
					token: '',
					encodingaeskey: ''
				},
				user_list: [],
				user_info: [],
				corpkey: '',

				input: '',

				info: {
					url: 'https://scrm.51kuaiding.com/hkt/qwcallbackurl/qw_call_back_url?corpkey=',
					token: 'oAfuQgQm',
					encodingAESKey: 'YiGaNAhWA75RS4CaznX7KdK5s63EyVu5ywgSVAX84An'
				},
				btnFlag: false,

				isEdit: false,

				member_list: [],

				// 同步信息弹窗
				synch_show: false,
				synch_dialog: {
					name: '企微资料同步',
					width: '625px'
				},

				dialog_type: 1,

				synch_select_info: {
					class_info: true,
					label_info: true,
					member_info: true,
					group_info: true
				},
				// 同步进度条
				progress_bar: 0,

				// 同步状态  0 等待同步、1 正在同步、2 同步成功
				class_state: 0,
				label_state: 0,
				member_state: 0,
				group_state: 0,

				// 同步返回结果
				class_msg: 0,
				label_msg: 0,
				member_msg: 0,
				group_msg: 0,

				// 进度条百分比
				data_num: {
					sum: 100,
					num: 4
				},

				// 正在同步的客户userid
				userid: '',
				next_cursor: '',

				// 正在执行同步的客户索引
				member_index: 0,
				group_index: 0

			}
		},
		filters: {
			round(num) {
				return Math.ceil(num)
			}
		},
		created() {
			this.getQwConfig()
		},
		mounted() {
			window.addEventListener('scroll', this.scrollToTop)
		},
		destroyed() {
			window.removeEventListener('scroll', this.scrollToTop)
		},
		methods: {
			getUser() {
				if (this.config.company_name !== '' && this.config.corpid !== '' && this.config.agent_secret !== '') {
					this.getQwUser(this.config.corpid, this.config.agent_secret)
				} else {
					this.$message({
						message: '请先执行第一步和第三步的步骤',
						type: 'warning',
						offset: 100
					});
				}

			},
			save() {
				if (this.isEdit) {
					this.editQwConfig(this.config)
				} else {
					// this.config.userid = []
					// for (let index in this.user_info) {
					// 	for (let index1 in this.user_list) {
					// 		if (this.user_list[index1].userid == this.user_info[index]) {
					// 			this.config.userid.push(this.user_list[index1].userid)
					// 		}
					// 	}
					// }
					
					// this.config.userid = this.config.userid.join()

					this.setQwConfig(this.config)
				}

			},

			jump(index) {
				let jump = document.querySelectorAll('.d_jump')
				// 获取需要滚动的距离
				let total = jump[index].offsetTop
				// Chrome
				let distance = document.documentElement.scrollTop || document.body.scrollTop
				// 计算每一小段的距离
				let step = total / 50;
				(function smoothDown() {
					if (distance < total) {
						distance += step
						// 移动一小段
						document.body.scrollTop = distance
						document.documentElement.scrollTop = distance
						// 设定每一次跳动的时间间隔为10ms
						setTimeout(smoothDown, 10)
					} else {
						// 限制滚动停止时的距离
						document.body.scrollTop = total
						document.documentElement.scrollTop = total
					}
				})()
			},
			// 点击图片回到顶部方法，加计时器是为了过渡顺滑
			backTop() {
				const that = this
				let timer = setInterval(() => {
					let ispeed = Math.floor(-that.scrollTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
					if (that.scrollTop === 0) {
						clearInterval(timer)
					}
				}, 16)
			},

			// 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
			scrollToTop() {
				const that = this
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				that.scrollTop = scrollTop
				if (that.scrollTop > 60) {
					that.btnFlag = true
				} else {
					that.btnFlag = false
				}
			},



			copyName() {
				let clipboard = new Clipboard('.copy_name')
				clipboard.on('success', e => {
					this.$message({
						message: '复制成功',
						type: 'success',
						offset: 100
					});
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.$message({
						message: '该浏览器不支持自动复制',
						type: 'error',
						offset: 100
					});
					clipboard.destroy()
				})
			},
			copyUrl() {
				if (this.config.corpid === '') {
					this.$message({
						message: '请先在第一步填写企业ID',
						type: 'warning',
						offset: 100
					});
				} else {
					let clipboard = new Clipboard('.copy_url')
					clipboard.on('success', e => {
						this.$message({
							message: '复制成功',
							type: 'success',
							offset: 100
						});
						clipboard.destroy()
					})
					clipboard.on('error', e => {
						this.$message({
							message: '该浏览器不支持自动复制',
							type: 'error',
							offset: 100
						});
						clipboard.destroy()
					})
				}

			},
			copyToken() {
				let clipboard = new Clipboard('.copy_token')
				clipboard.on('success', e => {
					this.$message({
						message: '复制成功',
						type: 'success',
						offset: 100
					});
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.$message({
						message: '该浏览器不支持自动复制',
						type: 'error',
						offset: 100
					});
					clipboard.destroy()
				})
			},
			copyAESKey() {
				let clipboard = new Clipboard('.copy_aeskey')
				clipboard.on('success', e => {
					this.$message({
						message: '复制成功',
						type: 'success',
						offset: 100
					});
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.$message({
						message: '该浏览器不支持自动复制',
						type: 'error',
						offset: 100
					});
					clipboard.destroy()
				})
			},
			copyUrl1() {
				let clipboard = new Clipboard('.copy_url1')
				clipboard.on('success', e => {
					this.$message({
						message: '复制成功',
						type: 'success',
						offset: 100
					});
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.$message({
						message: '该浏览器不支持自动复制',
						type: 'error',
						offset: 100
					});
					clipboard.destroy()
				})
			},
			copyName1() {
				let clipboard = new Clipboard('.copy_name1')
				clipboard.on('success', e => {
					this.$message({
						message: '复制成功',
						type: 'success',
						offset: 100
					});
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.$message({
						message: '该浏览器不支持自动复制',
						type: 'error',
						offset: 100
					});
					clipboard.destroy()
				})
			},
			copyKjhh() {
				if (this.config.corpid === '') {
					this.$message({
						message: '请先在第一步填写企业ID',
						type: 'warning',
						offset: 100
					});
				} else {
					let clipboard = new Clipboard('.copy_kjhh')
					clipboard.on('success', e => {
						this.$message({
							message: '复制成功',
							type: 'success',
							offset: 100
						});
						clipboard.destroy()
					})
					clipboard.on('error', e => {
						this.$message({
							message: '该浏览器不支持自动复制',
							type: 'error',
							offset: 100
						});
						clipboard.destroy()
					})
				}
			},
			copyName2() {
				let clipboard = new Clipboard('.copy_name2')
				clipboard.on('success', e => {
					this.$message({
						message: '复制成功',
						type: 'success',
						offset: 100
					});
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.$message({
						message: '该浏览器不支持自动复制',
						type: 'error',
						offset: 100
					});
					clipboard.destroy()
				})
			},
			copyKhhx() {
				if (this.config.corpid === '') {
					this.$message({
						message: '请先在第一步填写企业ID',
						type: 'warning',
						offset: 100
					});
				} else {
					let clipboard = new Clipboard('.copy_khhx')
					clipboard.on('success', e => {
						this.$message({
							message: '复制成功',
							type: 'success',
							offset: 100
						});
						clipboard.destroy()
					})
					clipboard.on('error', e => {
						this.$message({
							message: '该浏览器不支持自动复制',
							type: 'error',
							offset: 100
						});
						clipboard.destroy()
					})
				}
			},

			// 下载logo
			downloadLogo() {
				var img = document.getElementById('hideImg'); // 获取要下载的图片
				var url = img.src; // 获取图片地址
				var a = document.createElement('a'); // 创建一个a节点插入的document
				var event = new MouseEvent('click') // 模拟鼠标click点击事件
				a.download = 'logo' // 设置a节点的download属性值
				a.href = url; // 将图片的src赋值给a节点的href
				a.dispatchEvent(event)
			},

			// 初始化数据
			initializationData() {
				this.synch_select_info = {
					class_info: true,
					label_info: true,
					member_info: true,
					group_info: true
				}
				this.progress_bar = 0
				this.class_state = 0
				this.label_state = 0
				this.member_state = 0
				this.group_state = 0
				this.class_msg = 0
				this.label_msg = 0
				this.member_msg = 0
				this.group_msg = 0
				this.data_num = {
					sum: 100,
					num: 4
				}
				this.userid = ''
				this.next_cursor = ''
				this.member_index = 0
				this.group_index = 0
				this.dialog_type = 1
			},



			// 判断是否全部同步完成
			isSynch() {
				let that = this
				if (this.progress_bar === 100) {
					setTimeout(function() {
						that.dialog_type = 3
						that.synch_dialog.name = '同步成功'
					}, 1000)
				}
			},

			start_synch_dialog() {

				this.class_state = 1
				this.synchroQwDepartment()


				this.dialog_type = 2
			},
			suspend_synch_dialog() {
				this.dialog_type = 3
			},
			return_synch_dialog() {
				this.synch_show = false
			},

			close_synch_dialog() {
				this.synch_show = false
			},


			// 接入企微
			setQwConfig(data) {
				setQwConfig(data).then(res => {
					if (res.code === 10000) {
						this.initializationData()
						this.synch_show = false
						this.getQwMember()
						
						localStorage.setItem('is_binding', 1);
						
						this.$router.back()
					} else if (res.code === 10001) {
						this.$message({
							message: res.message,
							type: 'error',
							offset: 100
						});
					}
				})
			},
			// 获取企微成员
			getQwUser(corpid, agent_secret) {
				getQwUser(corpid, agent_secret).then(res => {
					if (res.code === 10000) {
						this.user_list = res.result.userlist
					}
				})
			},
			// 获取企业信息
			getQwConfig() {
				getQwConfig().then(res => {
					if (res.code === 10000) {
						if (res.result === null) {
							this.isEdit = false
						} else {
							this.config.id = res.result.id
							this.config.company_name = res.result.company_name
							this.config.corpid = res.result.corpid
							this.config.agentid = res.result.agentid
							this.config.agent_secret = res.result.agent_secret
							this.config.customer_secret = res.result.customer_secret
							this.config.address_secret = res.result.address_secret

							this.isEdit = true
							this.getCallbackConfig(this.config.corpid)
						}

					}
				})
			},
			// 编辑配置
			editQwConfig(data) {
				editQwConfig(data).then(res => {
					if (res.code === 10000) {
						this.$message({
							message: '保存成功',
							type: 'success',
							offset: 100
						});
						// this.$router.go(-1);
						this.$router.back()
					} else {
						this.$message({
							message: res.message,
							type: 'error',
							offset: 100
						});
					}
				})
			},
			// 获取token
			getCallbackConfig(corpid) {
				getCallbackConfig(corpid).then(res => {
					if (res.code === 10000) {
						this.corpkey = res.message.corpkey
						this.config.token = res.message.token
						this.config.encodingaeskey = res.message.encodingaeskey
					}
				})
			},


			// 同步部门
			synchroQwDepartment() {
				synchroQwDepartment().then(res => {
					if (res.code === 10000) {
						this.class_msg = res.result
						this.class_state = 2
						this.progress_bar += this.data_num.sum / this.data_num.num
						this.isSynch()
						if (this.synch_select_info.label_info) {
							this.label_state = 1
							this.synchroQwTag()
						} else if (this.synch_select_info.member_info) {
							this.member_state = 1
							this.synchroQwCustomer(this.member_list[this.member_index].userid)
						} else if (this.synch_select_info.group_info) {
							this.group_state = 1
							this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
						}
					}
				})
			},
			// 同步标签
			synchroQwTag() {
				synchroQwTag().then(res => {
					if (res.code === 10000) {
						this.label_msg = res.result
						this.label_state = 2
						this.progress_bar += this.data_num.sum / this.data_num.num
						this.isSynch()
						if (this.synch_select_info.member_info) {
							this.member_state = 1
							this.synchroQwCustomer(this.member_list[this.member_index].userid)
						} else if (this.synch_select_info.group_info) {
							this.group_state = 1
							this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
						}
					}
				})
			},
			// 同步客户
			synchroQwCustomer(userid, next_cursor) {
				synchroQwCustomer(userid, next_cursor).then(res => {
					if (res.code === 10000) {
						this.member_msg += res.result.data_count
						if (res.result.next_cursor != '') {
							this.synchroQwCustomer(res.result.userid, res.result.next_cursor)
						} else {
							if (this.member_index < this.member_list.length - 1) {
								this.member_index += 1
								this.synchroQwCustomer(this.member_list[this.member_index].userid)
							} else {
								this.member_state = 2
								this.progress_bar += this.data_num.sum / this.data_num.num
								this.isSynch()
								if (this.synch_select_info.group_info) {
									this.group_state = 1
									this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
								}
							}
						}
					}
				})
			},
			// 同步客户群
			synchroQwCustomerBase(userid, next_cursor) {
				synchroQwCustomerBase(userid, next_cursor).then(res => {
					if (res.code === 10000) {
						this.group_msg += res.result.data_count
						if (res.result.next_cursor != '') {
							this.synchroQwCustomerBase(res.result.userid, res.result.next_cursor)
						} else {
							if (this.group_index < this.member_list.length - 1) {
								this.group_index += 1
								this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
							} else {
								this.group_state = 2
								this.progress_bar += this.data_num.sum / this.data_num.num
								this.isSynch()
							}
						}
					}
				})
			},



			// 获取已同步企微成员
			getQwMember() {
				getQwMember().then(res => {
					if (res.code === 10000) {
						this.member_list = res.result
					}
				})
			},
		}
	}
</script>

<style scoped>
.course {
	width: 100%;
}

.inner {
	padding: 32px 133px 225px 130px;
	border-radius: 2px;
	margin: 24px auto 0;
	max-width: 983px;
	background: #fff;
}

.inner .title-box {
	display: flex;
	justify-content: center;
}

.inner .title-box h2 {
	color: rgba(0, 0, 0, .85);
	line-height: 28px;
	margin-bottom: 22px;
	font-size: 20px;
	font-weight: 700;
}

.inner .title-list h4 {
	margin-bottom: 10px;
}

.inner .title-list span {
	cursor: pointer;
	color: rgba(0, 0, 0, .65);
	line-height: 1.5;
}

.inner .step {
	margin-top: 44px;
}

.inner .step .sub-title {
	font-size: 18px;
	color: rgba(0, 0, 0, .85);
	line-height: 25px;
	padding-bottom: 14px;
	border-bottom: 1px solid hsla(0, 0%, 93.3%, .93);
	position: relative;
	font-weight: 500;
}

.inner .step .sub-title:after {
	content: "";
	width: 62px;
	height: 3px;
	position: absolute;
	bottom: 0;
	background: var(--themeColors);
	left: 0;
}

.inner .step .docs {
	background: var(--themeColorsTint);
	border-radius: 4px;
	margin-top: 12px;
	font-weight: 500;
}

.inner .step .docs li {
	font-size: 14px;
	position: relative;
	padding: 10px 0 10px 26px;
	color: rgba(0, 0, 0, .85);
}

.inner .step .docs li .bold {
	color: #000;
}

.inner .step .docs li:after {
	content: "";
	position: absolute;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--themeColors);
	left: 12px;
	top: 17px;
	font-size: 14px;
	color: rgba(0, 0, 0, .85);
	line-height: 20px;
}

.inner .step img {
	max-width: 100%;
	margin-top: 12px;
}

.inner .step .docs li span {
	color: var(--themeColors);
}

.inner .step .docs li:after {
	content: "";
	position: absolute;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--themeColors);
	left: 12px;
	top: 17px;
	font-size: 14px;
	color: rgba(0, 0, 0, .85);
	line-height: 20px;
}

.inner .step.info .box .item {
	margin-top: 24px;
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
}

.inner .step.info .box .item1 {
	width: 670px;
	margin-top: 24px;
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	flex-direction: column;
	padding: 30px 20px;
	background: rgb(248, 248, 248);
}

.inner .step.info .box .item1:last-child {
	background: none;
	width: 200px;
	margin-top: 0;
}

.inner .step.info .box .item1>.title {
	min-width: 64px;
	margin-right: 9px;
	color: rgba(0, 0, 0, .65);
	font-size: 14px;
}

.inner .step.info .box .item>.title {
	min-width: 64px;
	margin-right: 9px;
	color: rgba(0, 0, 0, .65);
	font-size: 14px;
}

.inner .step .warning {
	margin-top: 12px;
}

.inner .step .warning .desc {
	color: #e62918;
	font-size: 14px;
	line-height: 24px;
	background: #fff5f5;
	padding: 3px 8px;
	text-align: left;
	margin-top: 7px;
}

.inner .step.change-right .box .item {
	margin-top: 24px;
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
}

.inner .step.change-right .box .item>.title {
	min-width: 64px;
	text-align: right;
	margin-right: 9px;
	color: rgba(0, 0, 0, .65);
	font-size: 14px;
}

.inner .step.callback .box {
	margin-top: 16px;
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
}

.inner .step.callback .box .item {
	padding: 10px 13px;
	background: #f8f8f8;
	border-radius: 2px;
	width: 646px;
	height: 64px;
	margin-right: 12px;
}

.inner .step.callback .box .item p {
	text-align: left;
	color: rgba(0, 0, 0, .85);
	font-size: 15px;
}

.inner .step.callback .box .item p.title {
	color: rgba(0, 0, 0, .45);
	font-size: 13px;
}

.inner .step.callback .warning {
	margin-top: 24px;
}

.inner .step .sub-step {
	margin-top: 33px;
}

.inner .step .sub-step>p {
	font-size: 14px;
	color: rgba(0, 0, 0, .85);
	line-height: 20px;
	text-align: left;
}

.bold-bold {
	font-weight: 600;
}

.inner .step .copy-box {
	display: -webkit-box;
	display: flex;
	margin-top: 10px;
}

.inner .step .copy-box .textarea {
	max-width: 428px;
	background: #f8f8f8;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, .15);
	padding: 9px 13px 11px;
	font-size: 15px;
	color: rgba(0, 0, 0, .85);
	line-height: 22px;
	margin-right: 16px;
	word-break: break-all;
}

.flex-row.align-center {
	-webkit-box-pack: center;
	justify-content: center;
}

.flex-row {
	display: -webkit-box;
	display: flex;
	-webkit-box-pack: start;
	justify-content: flex-start;
	-webkit-box-align: center;
	align-items: center;
	padding: 0;
}

.inner .step .copy-box .clickable {
	color: var(--themeColors);
}

.no-select {
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.clickable {
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.inner .step .sub-step {
	margin-top: 33px;
}

.inner .step.sidebar p {
	font-size: 14px;
	color: rgba(0, 0, 0, .85);
	line-height: 20px;
	text-align: left;
	margin-top: 20px;
}

.inner .step.sidebar .intro-desc .desc-title {
	font-size: 18px;
	font-weight: 600;
	color: rgba(0, 0, 0, .85);
	line-height: 25px;
	position: relative;
	padding-left: 17px;
}

.inner .step.sidebar .intro-desc .desc-title:before {
	position: absolute;
	content: "";
	width: 4px;
	height: 17px;
	background: var(--themeColors);
	left: 0;
	top: 2px;
}

.inner .step.sidebar .intro-desc .warning-desc {
	font-size: 14px;
	font-weight: 400;
	color: #e62918;
	line-height: 20px;
	padding: 8px 12px;
	background: #fff5f5;
	border-radius: 2px;
	margin-top: 13px;
	margin-bottom: 24px;
}

.ant-steps {
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	color: rgba(0, 0, 0, .65);
	font-size: 14px;
	font-variant: tabular-nums;
	line-height: 1.5;
	list-style: none;
	-webkit-font-feature-settings: "tnum";
	font-feature-settings: "tnum";
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	width: 100%;
	font-size: 0;
}

.inner .step.sidebar .steps .ant-steps-item {
	margin-right: 10px;
	font-weight: 600;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
	margin-right: 16px;
	white-space: nowrap;
}

.ant-steps .ant-steps-item {
	-webkit-box-flex: 0;
	flex: none;
}

.ant-steps-item {
	position: relative;
	display: inline-block;
	-webkit-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	overflow: hidden;
	vertical-align: top;
}

.ant-steps .ant-steps-item .ant-steps-item-container {
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
}

.ant-steps-item-container {
	outline: none;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {
	display: none;
}

.ant-steps-item-tail {
	position: absolute;
	top: 12px;
	left: 0;
	width: 100%;
	padding: 0 10px;
}

.inner .step.sidebar .steps .ant-steps-item.ant-steps-item-active .ant-steps-item-container .ant-steps-item-icon {
	background: var(--themeColors);
}

.inner .step.sidebar .steps .ant-steps-item .ant-steps-item-container .ant-steps-item-icon {
	background: #ccd5de;
	border: none;
	width: 28px;
	height: 28px;
}

.ant-steps .ant-steps-item-icon {
	width: 28px;
	height: 28px;
	line-height: 28px;
	border-radius: 28px;
	font-size: 12px;
	font-weight: 700;
	color: #fff;
}

.ant-steps-item-process .ant-steps-item-icon {
	background: var(--themeColors);
}

.ant-steps-item-process .ant-steps-item-icon {
	background-color: #fff;
	border-color: var(--themeColors);
}

.ant-steps-item-icon {
	width: 32px;
	height: 32px;
	margin-right: 8px;
	font-size: 16px;
	font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
	line-height: 32px;
	text-align: center;
	border: 1px solid rgba(0, 0, 0, .25);
	border-radius: 32px;
	-webkit-transition: background-color .3s, border-color .3s;
	transition: background-color .3s, border-color .3s;
}

.inner .step.sidebar .steps .ant-steps-item .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon {
	color: #fff;
}

.ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon {
	color: #fff;
}

.ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon {
	color: var(--themeColors);
}

.ant-steps-item-icon>.ant-steps-icon {
	position: relative;
	top: -1px;
	color: var(--themeColors);
	line-height: 1;
}

.ant-steps-item-content,
.ant-steps-item-icon {
	display: inline-block;
	vertical-align: top;
}

.inner .step.sidebar .steps .ant-steps-item .ant-steps-item-container .ant-steps-item-content .ant-steps-item-title {
	padding-right: 10px;
	font-size: 15px;
}

.inner .step.sidebar .steps .ant-steps-item.ant-steps-item-active .ant-steps-item-container .ant-steps-item-title {
	color: var(--themeColors);
	font-weight: 600;
}

.inner .step.sidebar .steps .ant-steps-item:first-child .ant-steps-item-title {
	padding-right: 10px;
}

.ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title {
	color: rgba(0, 0, 0, .85);
}

.ant-steps-item-process .ant-steps-item-title {
	font-weight: 500;
}

.ant-steps-item-title {
	position: relative;
	display: inline-block;
	padding-right: 16px;
	color: rgba(0, 0, 0, .65);
	font-size: 16px;
	line-height: 32px;
}

.ant-steps .ant-steps-item .ant-steps-item-container .ant-steps-item-part-line {
	width: 72px;
	height: 1px;
	background: #e8e8e8;
}

.inner .step.sidebar .step-container {
	margin-top: 20px;
}

.container {
	background: #fff;
}

.inner .step.sidebar .step-container .btn-wrap {
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	-webkit-box-pack: end;
	justify-content: flex-end;
	margin-top: 24px;
	font-size: 14px;
	font-weight: 400;
	color: rgba(0, 0, 0, .66);
	line-height: 20px;
}

.inner .step.sidebar .btn-wrap {
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	margin-top: 24px;
	-webkit-box-pack: end;
	justify-content: flex-end;
}

.hide {
	display: none;
}

.button {
	border-radius: 2px;
	width: 80px;
	height: 28px;
	padding: 0;
	border: none;
	color: #fff;
	background: var(--themeColors);
}

.button:hover {
	background: var(--themeColors);
}

.config-btn {
	width: 188px;
	height: 40px;
	border: none;
	border-radius: 2px;
	margin-left: 24px;
	background: var(--themeColors);
	color: #fff;
}

.config-btn:hover {
	background: var(--themeColorsHover);
}

.clickable {
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.course .to-up {
	position: fixed;
	right: 200px;
	bottom: 150px;
	cursor: pointer;

}



#hideImg {
	display: none;
}

.downloadLogo {
	cursor: pointer;
}


/deep/ .el-input__inner {
	border: 1px solid var(--themeColors);
	box-shadow: 0px 0px 10px 0px var(--themeColors);

	animation-name: color;
	animation-duration: 2s;
	animation-iteration-count: infinite;
}

@keyframes color {
	0% {
		border: 1px solid var(--themeColors);
		box-shadow: 0px 0px 10px 0px var(--themeColors);
	}

	50% {
		border: 1px solid rgb(249, 104, 104);
		box-shadow: 0px 0px 3px 0px rgb(249, 104, 104);
	}

	100% {
		border: 1px solid var(--themeColors);
		box-shadow: 0px 0px 10px 0px var(--themeColors);
	}
}



.dialog .synch_select {
	display: flex;
	justify-content: center;
}

.dialog .synch_select .title-box {
	width: 420px;
	margin-left: 15px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.dialog .synch_select .title-box .title {
	font-size: 16px;
	color: rgb(56, 56, 56);
}

.dialog .synch_select .title-box .small-title {
	font-size: 14px;
	color: rgb(166, 166, 166);
	margin-top: 10px;
}

/deep/ .dialog .synch_speed .el-progress-bar {
	width: 95%;
}

/deep/ .dialog .synch_speed .el-progress-bar__outer {
	height: 10px !important;
}

/deep/ .dialog .synch_speed .el-progress__text {
	font-size: 18px !important;
	font-weight: bold;
	margin-left: 25px;
}

.dialog .synch_speed .return_info {
	margin-top: 50px;
}

.dialog .synch_speed .return_info p {
	color: rgb(56, 56, 56);
	line-height: 2;
}

.dialog .synch_success {
	display: flex;
	justify-content: center;
}

.dialog .synch_success .title-box {
	width: 420px;
	margin-left: 15px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.dialog .synch_success .title-box .title {
	font-size: 16px;
	color: rgb(56, 56, 56);
}

.dialog .synch_success .title-box .small-title {
	font-size: 14px;
	color: rgb(166, 166, 166);
	margin-top: 10px;
}

.dialog .wait {
	font-size: 12px;
	color: rgb(166, 166, 166);
}

.dialog .ongoing {
	font-size: 12px;
	color: rgb(255, 141, 26);
}

.dialog .success {
	font-size: 12px;
	color: rgb(39, 165, 56);
}

.dialog .data-text {
	font-size: 12px;
	color: rgb(166, 166, 166);
}

.dialog .suspend {
	background: rgb(255, 141, 26);
	border-color: rgb(255, 141, 26);
}

.dialog .suspend:hover {
	background: #f77c00;
	border-color: #f77c00;
}

.dialog .blueBtn:focus {
	background: var(--themeColors);
	color: #fff;
	border-color: var(--themeColors);
}

.dialog .suspend:focus {
	background: rgb(255, 141, 26);
	color: #fff;
	border-color: rgb(255, 141, 26);
}
</style>
